import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

const swiperInstances = new Set();
let resizeTimer;

function buildBreakpoints(swiperEl) {
	const columns = swiperEl.dataset.sliderColumns;
	const desktopSlidesPerView = swiperEl.dataset.sliderColumnsDesktop;
	const tabletSlidesPerView = swiperEl.dataset.sliderColumnsTablet;
	const mobileSlidesPerView = swiperEl.dataset.sliderColumnsMobile;

	let breakpoints = {
		320: {
			slidesPerView: mobileSlidesPerView ? mobileSlidesPerView : 1,
			spaceBetween: 8,
		},
		640: {
			slidesPerView: tabletSlidesPerView ? tabletSlidesPerView : 2,
			spaceBetween: 8,
		},
		1024: {
			slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 4,
			spaceBetween: 16,
		},
	};

	if ((columns && columns == '4') || desktopSlidesPerView == '4') {
		breakpoints = {
			320: {
				slidesPerView: mobileSlidesPerView ? mobileSlidesPerView : 1.1,
				spaceBetween: 8,
			},
			500: {
				slidesPerView: tabletSlidesPerView ? tabletSlidesPerView : 2,
			},
			640: {
				slidesPerView: tabletSlidesPerView ? tabletSlidesPerView : 3,
			},
			1024: {
				slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 4,
				spaceBetween: 16,
			},
		};
	}

	if ((columns && columns == '2') || desktopSlidesPerView == '2') {
		breakpoints = {
			640: {
				slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 2,
				spaceBetween: 16,
			},
		};
	}

	if ((columns && columns == '1') || desktopSlidesPerView == '1') {
		breakpoints = {
			640: {
				slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 1,
				spaceBetween: 16,
			},
		};
	}

	return breakpoints;
}

function scheduleSwiperUpdate() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => {
		swiperInstances.forEach((swiper) => {
			swiper.update();
			if (swiper.scrollbar) {
				swiper.scrollbar.updateSize();
			}
		});
	}, 150);
}

function initStrainsSlider(module) {
	const swiperEl = module.querySelector('.swiper');
	if (!swiperEl) {
		return;
	}

	const next = module.querySelector('.slider-nav-next');
	const prev = module.querySelector('.slider-nav-prev');
	const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');
	const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

	if (swiperEl.swiper) {
		swiperEl.swiper.destroy(true, true);
	}

	const swiperParams = {
		modules: [Navigation, Scrollbar],
		slidesPerView: 1,
		spaceBetween: 8,
		watchOverflow: true,
		navigation: {
			nextEl: next,
			prevEl: prev,
		},
		scrollbar: {
			el: scrollbarEl,
			draggable: true,
			hide: false,
		},
		breakpoints: buildBreakpoints(swiperEl),
	};

	if (totalSlides <= 1 && next && prev) {
		next.style.display = 'none';
		prev.style.display = 'none';
	}

	const swiper = new Swiper(swiperEl, swiperParams);
	swiperInstances.add(swiper);

	if (swiper.scrollbar) {
		swiper.scrollbar.updateSize();
	}

	const stage = module.querySelector('.strains-slider-stage');
	if (stage) {
		const updateSliderFades = () => {
			stage.classList.toggle('is-at-beginning', swiper.isBeginning);
			stage.classList.toggle('is-at-end', swiper.isEnd);
		};

		updateSliderFades();
		swiper.on('slideChange', updateSliderFades);
		swiper.on('resize', updateSliderFades);
		swiper.on('transitionEnd', updateSliderFades);
		swiper.on('scrollbarDragMove', updateSliderFades);
	}
}

function initStrainsSliders() {
	swiperInstances.clear();
	document.querySelectorAll('.module-strains-slider').forEach(initStrainsSlider);
}

document.addEventListener('DOMContentLoaded', initStrainsSliders);
window.addEventListener('resize', scheduleSwiperUpdate);
